
// Task detail routes are directly included in this file
import globalConstants from '@/plugins/constants';
export default [
    {
        path: '/chatbot',
        component: "__base",
        otherdata: { color: "others" },
        children: [
            {
                path: "home", 
                component: "ChatBot.vue",
                meta: { title: globalConstants.ASK_NOA_LABEL}, 
            },
            {
                path: "*",
                component: "",
            },
        ],
    },
]

